import { changeDateFormat, changeDateFormatJavaToUi } from "./utility";
import { checkDate } from "./validation";

//Parameter is assumed to be String containing number or it's 'TBD'
export function tbdToNull(val:any){
    if(val){
        val=val.toString().trim().toUpperCase();
        if(!val)
            return 0;
        else{
            if(val=='TBD')
                return null;
            else
                return parseInt(val);
        }
    }
    else{
        return 0;
    }
}

//Parameter is assumed to be number or null
export function nullToTbd(val:any){
    if(val==null)
        return 'TBD';
    val = parseInt(val);
    return val.toString();
}

//Parameter is assumed to be number or null
export function nullToZero(val:any){
    if(val==null || val==0)
        return 0;
    val = parseInt(val);
    return val;
}


//Parameter is assumed to be string
export function keyDatesDateUiToService(date:any) {
    if(!date)
        return '';
    date = date.toString().trim();
    if(!date)
        return '';
    else if(date.toUpperCase()=="TBD"){
        return "TBD";
    }
    else if(date.toUpperCase()=="COMPLETED"){
        return "COMPLETED";
    }
    else if(date.toUpperCase()=="N/A"){
        return "N/A";
    }
    else if(!date.includes('/') || date.length!=8){
        return '';
    }
    else if(!checkDate(date)){
        return "";
    }

    let newDate:any = new Date(date);

    if(newDate == 'Invalid Date'){
        return "";
    }
    return changeDateFormat(date,"yyyy-mm-dd");

}

//Parameter is assumed to be string
export function keyDatesDateServiceToUi(date:any) {
    if(!date)
        return "";
    date = date.toString().trim();
    let dt = changeDateFormatJavaToUi(date,"mm/dd/yy");
    if(!date)
        return "";
    else if(date.toUpperCase()=="TBD"){
        return "TBD";
    }
    else if(date.toUpperCase()=="COMPLETED"){
        return "COMPLETED";
    }
    else if(date.toUpperCase()=="N/A"){
        return "N/A";
    }
    else if(!dt || dt.length!=8){
        return "";
    }
    else if(!checkDate(dt)){
        return "";
    }
    let newDate:any = new Date(date);
    if(newDate == 'Invalid Date'){
        return "";
    }
    return dt;
}

// export function checkDateString(date:string,format:string){
//     let dateArray = date.trim().split('');
//     let len = dateArray.length;
//     let mm:number;
//     let dd:number;
//     if(format=="yyyy/mm/dd" || format=="yyyy-mm-dd"){
//         try {
//             mm = parseInt(dateArray[5]+dateArray[6]);
//             dd = parseInt(dateArray[8]+dateArray[9]);
//             if(mm>12 || mm<1 || dd<1 || dd>31){
//                 return false;
//             }
//         } catch (error) {
//             return false;
//         }
//     }
//     else{
//         try {
//             mm = parseInt(dateArray[0]+dateArray[1]);
//             dd = parseInt(dateArray[3]+dateArray[4]);
//             if(mm>12 || mm<1 || dd<1 || dd>31){
//                 return false;
//             }
//         } catch (error) {
//             return false;
//         }
//     }

//     if(format=="yyyy-mm-dd" || format=="yyyy/mm/dd"){
//         if(len!=10){
//             return false;
//         }
//         else if(dateArray[4] == '/' && dateArray[7] == '/' && format=="yyyy/mm/dd"){
//             return true;
//         }
//         else if(dateArray[4] == '-' && dateArray[7] == '-'){
//             return true;
//         }
//         else{
//             return false;
//         }
//     }

//     if(format=="mm-dd-yy" || format=="mm/dd/yy"){
//         if(len!=8){
//             return false;
//         }
//         else if(dateArray[2] == '/' && dateArray[5] == '/' && format=="mm/dd/yy"){
//             return true;
//         }
//         else if(dateArray[2] == '-' && dateArray[5] == '-'){
//             return true;
//         }
//         else{
//             return false;
//         }
//     }

//     return false;
// }